export default __webpack_public_path__ + "static/media/icon_book_black.b0eb58a7.svg";